var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-status"},[_c('el-tag',{attrs:{"type":_vm.statusType,"size":"medium"}},[_vm._v(_vm._s(_vm.statusText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }